import { render, staticRenderFns } from "./WAChatHeader.vue?vue&type=template&id=4dfe0eaf&scoped=true"
import script from "./WAChatHeader.vue?vue&type=script&lang=js"
export * from "./WAChatHeader.vue?vue&type=script&lang=js"
import style0 from "./WAChatHeader.vue?vue&type=style&index=0&id=4dfe0eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe0eaf",
  null
  
)

export default component.exports